import React, { useEffect, useState } from "react";
import axios from "axios";
import "./_newsPage.scss";

const NewsPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch book-related news
  const fetchNews = async () => {
    const API_URL = `${process.env.REACT_APP_API_URL}/api/news`; // Fetch from your backend

    try {
      setLoading(true);
      const response = await axios.get(API_URL);
      setArticles(response.data.articles); // Store fetched articles
    } catch (error) {
      console.error("Error fetching news articles:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  return (
    <div className="news-page">
      <h1>Book News</h1>
      {loading ? (
        <p>Loading news...</p>
      ) : (
        <div className="news-container">
          {articles.length > 0 ? (
            articles
            .filter((article) => article.urlToImage) // ✅ Only show articles with images
            .map((article, index) => (
              <div key={index} className="news-article">
                <img loading="lazy"
                  src={article.urlToImage || "/default_news_image.jpg"}
                  alt={article.title}
                />
                <div className="news-content">
                  <h2>{article.title}</h2>
                  <p>{article.description}</p>
                  <a href={article.url} target="_blank" rel="noopener noreferrer">
                    Read more
                  </a>
                </div>
              </div>
            ))
          ) : (
            <p>No articles found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default NewsPage;
